import Register from '@/core/pages/auth/Register/Register';

export default Register;
